'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIphone = function IoIphone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.6 5c1 0 1.9 0.9 1.9 1.9v26.2c0 1-0.9 1.9-1.9 1.9h-11.2c-1 0-1.9-0.9-1.9-1.9v-26.2c0-1 0.9-1.9 1.9-1.9h11.2z m-6.8 2.8c0 0.2 0.1 0.3 0.3 0.3h1.8c0.2 0 0.4-0.1 0.4-0.3 0-0.1-0.2-0.3-0.4-0.3h-1.8c-0.2 0-0.3 0.2-0.3 0.3z m-1-0.3c-0.1 0-0.3 0.2-0.3 0.3s0.2 0.3 0.3 0.3 0.3-0.1 0.3-0.3-0.1-0.3-0.3-0.3z m2.2 26.3c0.7 0 1.3-0.6 1.3-1.3s-0.6-1.2-1.3-1.2-1.2 0.5-1.2 1.2 0.5 1.3 1.2 1.3z m6.3-3.8v-20h-12.5v20h12.5z' })
        )
    );
};

exports.default = IoIphone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/iphone.js
// module id = 2325
// module chunks = 0